import React from 'react';
import ProfileExperienceReview from './common/experience-review';

const PeerVideoReview: React.FunctionComponent = (): JSX.Element => {
  return <ProfileExperienceReview experienceType="video" />;
};

export default PeerVideoReview;
